import React, { useEffect } from 'react';
import type { FC } from 'react';
import {useLocation} from "react-router-dom";
import i18n from './i18nextSetup';

const LanguageInitializer: FC = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
        const languageFromPath = location.pathname.replace('/education/', '').split('/')[0];
    
        i18n.changeLanguage(languageFromPath);
    }, [pathname]);
    
  
    return null; 
  };

  export default LanguageInitializer;

  

  

  
  